import React from "react";
import styles from "./MeetTheTeam.module.css";
// import LinkedInIcon from "@material-ui/icons/LinkedIn";
// import Button from "@material-ui/core/Button";
const team = [
  { name: "SHIVANGI MOHANTY", role: "Web Dev" },
  { name: "ATIG PUROHIT", role: "ML" },
  { name: "SUBHAYAN DAS", role: "Web Dev" },
  { name: "SRINIKET JAYASENDI", role: "ML" },
  { name: "DURGESH KUMAR", role: "Web Dev" },
  { name: "GAURANSH SHUKLA", role: "ML" },
  { name: "ANUBHAB SWAIN", role: "ML" },
  { name: "AMAN KUMAR", role: "Web Dev" },
  { name: "JUBRAN PASHA", role: "Web Dev" },
  { name: "RONIT KAMILLA", role: "Web Dev" },
  { name: "PRITISH RANJAN PANDA", role: "Web Dev" },
];

const MeetTheTeam = () => {
  return (
    <div className={styles.mainContainerrr}>
      <div className={styles.secondaryContainer}>
        <div className={styles.top}>
          {/* <h1>Meet The Team</h1> */}
          <h1>
            ABOUT <span>US</span>
          </h1>
        </div>
        <div className={styles.center}>
          <div className={styles.centerSecondary}>
            <h2>ABOUT MSC KIIT - PROJECT WING</h2>
            <p className={styles.centerP1}>
              MSC KIIT is a technical community, under the wing of Microsoft
              Learn Student Ambassadors, showcasing and nurturing talents under
              the well known and esteemed name of the organisation, to carry
              forth and express it's legacy. We conduct events all over campus
              (and outside campus), inspiring students to pursue knowledge, in
              their own unique ways. Along with this, we aspire to give the push
              they need through our club's work, and through training in the
              various domains that we provide.
            </p>
            <p className={styles.centerP2}>
              MSC Project Wing is an accelerated online program to equip
              engineering students with skills that set them apart from the
              crowd by contributing and creating a major project that has some
              industry value. This program has been started with the vision of
              providing a base to the start-up ideas or product ideas within the
              developer community.
            </p>
          </div>
        </div>
        <div className={styles.bottom}>
          <h2>MEET THE TEAM</h2>
          <div className={styles.bottomSecondary}>
            {team.map((member) => {
              return (
                <div className={styles.singlePerson}>
                  <div className={styles.pictureContainer}>
                    <img
                      className={styles.singlePersonPic}
                      src="https://images.unsplash.com/photo-1527980965255-d3b416303d12?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=880&q=80"
                      alt=""
                    />
                  </div>
                  <h3>{member.name}</h3>
                  <h5>{member.role}</h5>
                </div>
              );
            })}
            {/* <div className={styles.singlePerson}>
              <div className={styles.pictureContainer}>
                <img
                  className={styles.singlePersonPic}
                  src="https://images.unsplash.com/photo-1527980965255-d3b416303d12?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=880&q=80"
                  alt=""
                />
              </div>
              <h3>
                HUNTER <br /> HUNTER
              </h3>
              <h5>CHAIRMAN</h5>
            </div>

            <div className={styles.singlePerson}>
              <div className={styles.pictureContainer}>
                <img
                  className={styles.singlePersonPic}
                  src="https://images.unsplash.com/photo-1527980965255-d3b416303d12?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=880&q=80"
                  alt=""
                />
              </div>
              <h3>
                HUNTER <br /> HUNTER
              </h3>
              <h5>CHAIRMAN</h5>
            </div>
            
            <div className={styles.singlePerson}>
              <div className={styles.pictureContainer}>
                <img
                  className={styles.singlePersonPic}
                  src="https://images.unsplash.com/photo-1527980965255-d3b416303d12?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=880&q=80"
                  alt=""
                />
              </div>
              <h3>
                HUNTER <br /> HUNTER
              </h3>
              <h5>CHAIRMAN</h5>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetTheTeam;
